import { render, staticRenderFns } from "./FifaDayView.vue?vue&type=template&id=2e4bedfe&scoped=true"
import script from "./FifaDayView.vue?vue&type=script&lang=js"
export * from "./FifaDayView.vue?vue&type=script&lang=js"
import style0 from "./FifaDayView.vue?vue&type=style&index=0&id=2e4bedfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bedfe",
  null
  
)

export default component.exports